// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"4a95b3a2","107":"4a95b3a2","171":"4a95b3a2","207":"4a95b3a2","266":"4a95b3a2","472":"4a95b3a2","581":"4a95b3a2","662":"4a95b3a2","840":"4a95b3a2"}[chunkId] + ".chunk.css";
};